
import React, { createContext, useContext, useState } from 'react';

interface WaitlistContextType {
  showThankYou: boolean;
  setShowThankYou: (show: boolean) => void;
}

const WaitlistContext = createContext<WaitlistContextType | undefined>(undefined);

export const WaitlistProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showThankYou, setShowThankYou] = useState(false);

  // Removed the auto-hide timer - thank you message will persist

  return (
    <WaitlistContext.Provider value={{ showThankYou, setShowThankYou }}>
      {children}
    </WaitlistContext.Provider>
  );
};

export const useWaitlist = () => {
  const context = useContext(WaitlistContext);
  if (context === undefined) {
    throw new Error('useWaitlist must be used within a WaitlistProvider');
  }
  return context;
};
